const MODULE = 'PKS'
export const FETCH_REQUEST = `${MODULE}/FETCH_REQUEST`
export const FETCH_SUCCESS = `${MODULE}/FETCH_SUCCESS`
export const FETCH_FAILED = `${MODULE}/FETCH_FAILED`
export const PK_SELECTED = `${MODULE}/SELECTED`
